import React from 'react'

import { Box } from '@chakra-ui/react'

import type { ColorScheme } from '../../types'

export type ShareIconProps = {
  size?: number
  color?: string
  colorScheme?: ColorScheme
}

const VIEWBOX_WIDTH = 17
const VIEWBOX_HEIGHT = 19

export const ShareIcon = ({
  size = VIEWBOX_WIDTH,
  color,
  colorScheme,
}: ShareIconProps) => {
  const scaledHeight = Math.round(size * (VIEWBOX_HEIGHT / VIEWBOX_WIDTH))

  return (
    <Box
      alignItems='center'
      color={
        color ??
        (colorScheme === 'light' ? 'light.icon.secondary' : 'icon.secondary')
      }
      display='flex'
      flexShrink={0}
      height={`${scaledHeight}px`}
      lineHeight={0}
      width={`${size}px`}
    >
      <svg
        fill='none'
        height={scaledHeight}
        viewBox={`0 0 ${VIEWBOX_WIDTH} ${VIEWBOX_HEIGHT}`}
        width={size}
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M5.40833 10.3417L11.1 13.6583M11.0917 4.50833L5.40833 7.825M15.75 3.25C15.75 4.63071 14.6307 5.75 13.25 5.75C11.8693 5.75 10.75 4.63071 10.75 3.25C10.75 1.86929 11.8693 0.75 13.25 0.75C14.6307 0.75 15.75 1.86929 15.75 3.25ZM5.75 9.08333C5.75 10.464 4.63071 11.5833 3.25 11.5833C1.86929 11.5833 0.75 10.464 0.75 9.08333C0.75 7.70262 1.86929 6.58333 3.25 6.58333C4.63071 6.58333 5.75 7.70262 5.75 9.08333ZM15.75 14.9167C15.75 16.2974 14.6307 17.4167 13.25 17.4167C11.8693 17.4167 10.75 16.2974 10.75 14.9167C10.75 13.536 11.8693 12.4167 13.25 12.4167C14.6307 12.4167 15.75 13.536 15.75 14.9167Z'
          stroke='currentColor'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='1.5'
        />
      </svg>
    </Box>
  )
}
